var React = require('react');

function CommonIcnMenu (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_129_3493)","key":0},React.createElement("path",{"d":"M3.75 18C3.33579 18 3 17.6642 3 17.25C3 16.8358 3.33579 16.5 3.75 16.5H20.25C20.6642 16.5 21 16.8358 21 17.25C21 17.6642 20.6642 18 20.25 18H3.75ZM3.75 12.75C3.33579 12.75 3 12.4142 3 12C3 11.5858 3.33579 11.25 3.75 11.25H20.25C20.6642 11.25 21 11.5858 21 12C21 12.4142 20.6642 12.75 20.25 12.75H3.75ZM3.75 7.5C3.33579 7.5 3 7.16421 3 6.75C3 6.33579 3.33579 6 3.75 6H20.25C20.6642 6 21 6.33579 21 6.75C21 7.16421 20.6642 7.5 20.25 7.5H3.75Z","fill":"white"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_129_3493"},React.createElement("rect",{"width":"24","height":"24","fill":"white"})))]);
}

CommonIcnMenu.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CommonIcnMenu;

CommonIcnMenu.default = CommonIcnMenu;
